// 학교 PC의 구형 브라우저(Chrome·Edge 92 이하)에는 Object.hasOwn 이 없어 react-markdown 렌더링에서
// 채팅 화면 전체가 깨졌다(2026-10-01 Edge 92, UI_CRASH "Object.hasOwn is not a function").
if (typeof Object.hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    value: (object, property) => {
      if (object === null || object === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    },
    configurable: true,
    writable: true,
  });
}

// Chrome·Edge 91, iOS Safari 15.3 이하에는 Array/String.prototype.at 이 없다(remark-cjk-friendly 의존성이 쓴다).
function at(index) {
  const length = this.length;
  const relative = Math.trunc(Number(index)) || 0;
  const k = relative >= 0 ? relative : length + relative;
  if (k < 0 || k >= length) return undefined;
  return this[k];
}
[Array.prototype, String.prototype].forEach((proto) => {
  if (typeof proto.at !== 'function') {
    Object.defineProperty(proto, 'at', { value: at, configurable: true, writable: true });
  }
});
